// extracted by mini-css-extract-plugin
export default {"mainWrapper":"ProfileSearchResults_mainWrapper__y9N7h"};